module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_100_157.61d9a74.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_100_157.jpg
// module id = HwCh
// module chunks = 0